// contrat_medecin.js
import newBranchet from "./branchetFn";
import titleize from "underscore.string/titleize";
import { renderRemuneration } from "./Remuneration";
var moment = require("moment");
var image1 = require("./logoOrdre");
moment.locale("fr");
const WIDTH = 450;

export function renderContratMedecin(contrat, pdf, stream) {
  console.log("contrat medecin");
  var titulaire = contrat.titulaireByTitulaireId;
  var remplacant = contrat.remplacantByRemplacantId;
  var nomCompletRemp =
    titleize(remplacant.prenom) + " " + remplacant.nom.toUpperCase();
  var nomCompletTitulaire =
    titleize(titulaire.prenom) + " " + titulaire.nom.toUpperCase();
  pdf.image(image1.image(), 250, 40, { scale: 0.3 });
  pdf.moveDown(5);
  pdf.text(" Contrat de remplacement en exercice libéral", { align: "center" });

  pdf.moveDown(1);
  pdf.text(
    "Articles R.4127-65 et R.4127-91 du code de la Santé publique (code de déontologie médicale)  \nRemplacement par un(e) docteur(e) en médecine  inscrit(e) au Tableau\nadopté le 9 février 1996 \nMAJ 2 octobre 2008\nMAJ 10 septembre 2020",
    { align: "center" }
  );
  pdf.moveDown(2);
  pdf.text(
    "Entre \nla docteure / le docteur" +
      nomCompletTitulaire +
      " (médecin anesthésiste, numéro d'inscription à l'ordre " +
      titulaire.ordre +
      " et numéro d'inscription au RPPS " +
      titulaire.rpps +
      ") "
  );
  pdf.text(
    "installé au Cabinet d'Anesthésie des Cèdres,48 avenue de Grugliasco 38130 Echirolles. d'une part, \net, \nla docteure / le docteur " +
      nomCompletRemp +
      "  (médecin anesthésiste, " +
      remplacant.adresse +
      " et numéro d'inscription à l'ordre, " +
      remplacant.ordre +
      ") \nimmatriculé à l’URSSAF, sous le numéro " +
      remplacant.urssaf +
      ","
  );

  pdf.text("d'autre part.");
  pdf.moveDown(1);
  pdf.text("PREAMBULE");
  pdf.text(
    "Dans le souci de respecter l'obligation déontologique qui est la sienne d'assurer la permanence des soins et conformément aux dispositions de l'article R.4127-65 du code de la santé publique (code de déontologie médicale), le Docteur " +
      nomCompletTitulaire +
      " a contacté la docteure / le docteur " +
      nomCompletRemp +
      " ,médecin remplaçant(e), pour prendre en charge, lors de la cessation temporaire de son activité professionnelle habituelle, les patients qui feraient appel à elle/lui. \nPour permettre le bon déroulement de ce remplacement, la  docteure / le docteur " +
      nomCompletTitulaire +
      " met à la disposition de la docteure / le docteur " +
      nomCompletRemp +
      " son cabinet de consultation, sis 48 Avenue de Grugliasco 38130 Echirolles et son secrétariat. \nLa docteure / le docteur " +
      nomCompletRemp +
      " assume de ce fait toutes les obligations inscrites dans le code de déontologie. Elle/Il ne peut aliéner son indépendance professionnelle sous quelque forme que ce soit.",
    { width: WIDTH }
  );

  pdf.moveDown(3);
  pdf.text("Il a été convenu ce qui suit :");
  pdf.moveDown(1);
  pdf.text("Article 1er");
  pdf.text(
    "Dans le souci de la permanence des soins, la docteur / le docteur" + nomCompletTitulaire +" charge la docteur / le docteur" +
      nomCompletRemp +
      " qui accepte, de le/la remplacer temporairement auprés de patients qui feraient appel à elle/lui.\nLes patients doivent être avertis dés que possible de la présence d'un(e) remplaçant(e), notamment lors de toute demande de visite à domicile ou de rendez-vous au cabinet médical.\nla docteur / le docteur" + nomCompletRemp +" doit consacrer à cette activité tout le temps nécessaire selon les modalités qu'elle/il fixe librement. Elle/il peut, avec l'accord préalable de  la docteur / le docteur" + nomCompletTitulaire +", exercer une autre activité médicale, y compris dans les locaux de la docteur / le docteur" + nomCompletTitulaire+"."
  );
  pdf.text(
    "Elle/il s'engage à donner, à tout malade faisant appel à elle/lui, des soins consciencieux et attentifs dans le respect des dispositions du code de déontologie. Hors le cas d'urgence, la/le remplacant(e) peut, dans les conditions de l'article R.4127-47 du code de la santé publique (code de déontologie médicale), refuser ses soins pour des raisons professionnelles ou personnelles.",
    { width: WIDTH }
  );
  pdf.moveDown(1);
  // TODO:
  pdf.text(
    "Article 2 Le présent contrat de remplacement est prévu pour une période de " +
      contrat.getCountDays +
      " jour(s) correspondant au(x) jour(s) suivant(s)" +
      "  : " +
      contrat.setDatesFields +
      ".",
    { width: WIDTH }
  );
  pdf.moveDown(1);
  pdf.text(
    "Article 3 Pendant la durée du présent contrat de remplacement et pour les besoins de son exécution, la docteure / le docteur " +
      nomCompletRemp +
      " a l'usage des locaux professionnels, installations et appareils que la docteure / le docteur " +
      nomCompletTitulaire +
      " met à sa disposition. Elle/il en fait un usage raisonnable. Compte tenu du caractère par nature provisoire de l'activité de la remplaçante/du remplçant, celui-ci s'interdit toute modification des lieux ou de leur destination.",
    { width: WIDTH }
  );
  pdf.moveDown(1);
  // TODO: awfull hack but what ?
  pdf.text("Article 4");
  if (remplacant.nom.toLowerCase() === "walker") {
    pdf.text(
      "Le Docteur " +
        nomCompletRemp +
        "  exerçant son art en toute indépendance, sera seul responsable vis-à-vis des patients et des tiers des conséquences de son exercice professionnel. Il conservera seul la responsabilité de son activité professionnelle, pour laquelle il sera assuré par l'assurance RCP du Dr " +
        nomCompletTitulaire +
        ". Il se rapprochera de cet assureur professionnel, le Cabinet Branchet, pour la couverture du remplacement envisagé.",
      { width: WIDTH }
    );
  } else {
    pdf.text(
      "La docteure / le docteur " +
        nomCompletRemp +
        "  exerçe son art en toute indépendance.Elle/il est seul(e) responsable vis-à-vis des patients et des tiers des conséquences de son exercice professionnel et conserve seul(e) la responsabilité de son activité professionnelle pour laquelle elle/il s'assure personnellement à ses frais à une compagnie notoirement solvable. Elle/il devra apporter la preuve de cette assurance avant le début de son activité.",
      { width: WIDTH }
    );
  }

  pdf.moveDown(1);
  pdf.text(
    "Article 5\nLa docteure / le docteur " +
      nomCompletRemp +
      "  utilisera conformément à la Convention nationale les ordonnances ainsi que les feuilles de soins et imprimés pré-identifiés au nom de la docteure / le docteur " +
      nomCompletTitulaire +
      "  et/ou sa propre CPS dans son activité relative aux seuls patients de la docteure / le docteur" +
      nomCompletTitulaire +
      " . En outre, elle/il devra faire mention de son identification personnelle sur les ordonnances, feuilles de soins et imprimés réglementaires qu'elle/il sera amené(e) à remplir.",
    { width: WIDTH }
  );
  pdf.moveDown(1);
  pdf.text(
    "Article 6\nLes deux co-contractant(e)s procédent à des déclarations fiscales et sociales indépendantes et supporteront personnellement,chacun(e) en ce qui les concerne, la totalité de leurs charges fiscales et sociales afférentes au dit remplacement.",
    { width: WIDTH }
  );
  pdf.moveDown(1);
  pdf.text(
    "Article 7\nLa docteure / le docteur " +
      nomCompletRemp +
      "  perçoit l'ensemble des honoraires correspondant aux actes effectués sur les patients à qui il/elle  a donné ses soins. Elle/il doit remplir les obligations comptables normales et habituelles qui lui sont imposées réglementairement. En fin de remplacement, la docteure / le docteur " +
      nomCompletTitulaire +
      "  reverse au Docteur  " +
      nomCompletRemp,
    { width: WIDTH }
  );

  renderRemuneration(pdf);

  pdf.moveDown(1);
  pdf.text(
    "Article 8 \nAux termes de l’article R4127-86 du code de la santé publique (code de déontologie médicale), un « médecin ou un étudiant qui a remplacé un de ses confrères pendant trois mois, consécutifs ou non, ne doit pas, pendant une période de deux ans, s'installer dans un cabinet où il puisse entrer en concurrence directe avec le médecin remplacé et avec les médecins qui, le cas échéant, exercent en association avec ce dernier, à moins qu'il n'y ait entre les intéressés un accord qui doit être notifié au conseil départemental. A défaut d'accord entre tous les intéressés, l'installation est soumise à l'autorisation du conseil départemental de l'Ordre.» \nConformément à la possibilité offerte par les dispositions ci-dessus, la docteure / le docteur" + nomCompletTitulaire + " renonce dès à présent à se prévaloir de l’interdiction d’installation prévue à l’article R4127-86 du code de la santé publique (code de déontologie médicale) et s’engage à donner à la docteure / au docteur" + nomCompletRemp + "l’accord éventuellement nécessaire de sa part à son installation et à notifier cet accord au conseil départemental.",
    { width: WIDTH }
  );
  pdf.moveDown(1);
  pdf.text(
    "Article 9 Conciliation\nTous les litiges ou différends relatifs notamment à la validité, l’interprétation, l’exécutionou la résolution du présent contrat, sont soumis avant tout recours à une conciliation confiée au conseil départemental de l’Ordre des médecins, en application de l’article R.4127-56 du code de la santé publique (code de déontologie médicale).",
    { width: WIDTH }
  );

  pdf.text(
    "Article 10 Arbitrage \nEn cas d’échec de la conciliation, les litiges ou différends relatifs à la validité, l’interprétation, l’exécution ou la résolution du présent contrat, seront soumis à l’arbitrage conformément au règlement d’arbitrage de la Chambre nationale d’arbitrage des médecins .Dès à présent, les parties conviennent de soumettre leur litige à trois arbitres désignés selon les modalités définies à l’article 4 du règlement d’arbitrage de la Chambre nationale d’Arbitrage des médecins.Le tribunal arbitral statuera avec les pouvoirs d’amiable compositeur. Les parties renoncent à la possibilité de faire appel.\nLe siège de la Chambre nationale d’Arbitrage des médecins est fixé à PARIS 17ème, 4 rue Léon JOST.",
    { width: WIDTH }
  );
  pdf.moveDown(1);
  pdf.text(
    "Article 11 \nLes parties affirment sur l'honneur n'avoir passé aucune contre-lettre ou avenant relatif au présent contrat qui ne soit soumis au Conseil départemental.",
    { width: WIDTH }
  );
  pdf.moveDown(1);
  pdf.text(
    "Article 12\nConformément  aux dispositions des articles R.4127-65 et 91 du code de la santé publique (code de déontologie médicale), ce contrat sera communiqué au Conseil départemental de l'Ordre avant le début du remplacement.\nSon renouvellement  sera soumis à ces mêmes dispositions.",
    { width: WIDTH }
  );
  pdf.moveDown(1);
  pdf.text(
    "Fait en trois exemplaires\n(dont un pour le Conseil départemental)\nLe " +
      moment(contrat.createdAt).format("DD/MM/YYYY")
  );

  pdf.moveDown(2);
  pdf.text(
    "La docteure/le docteur " +
      nomCompletTitulaire +
      "                  La docteure/le docteur " +
      nomCompletRemp,
    { align: "center" }
  );

  pdf.addPage();
  pdf.moveDown(1);
  pdf.text(
    "Cabinet d'Anesthésie des Cèdres\n48 avenue de Grugliasco\n38130 Echirolles\nTél: 04 56 58 12 50",
    40,
    40
  );
  pdf.text(
    "Echirolles, le " + moment(contrat.createdAt).format("DD/MM/YYYY"),
    340,
    140
  );
  pdf.moveDown(2);
  pdf.text(
    "Conseil de l'Ordre des Médecins\n1A boulevard de la Chantourne\n38700 La Tronche"
  );
  pdf.moveDown(2);
  pdf.text("Monsieur le Président,", 40);
  pdf.moveDown(2);
  pdf.text(
    "Je sollicite de votre haute bienveillance l'autorisation d'être remplacé",
    40
  );
  pdf.moveDown(1);
  pdf.text("- par le Docteur " + nomCompletRemp, 40);
  pdf.text("- pour le(s) jour(s) suivant(s) " + contrat.setDatesFields, 40);
  pdf.moveDown(2);
  pdf.text(
    "Merci de faire le retour de l'autorisation de remplacement par mail à l'adresse suivante:\nsecret.anesthesie@cliniquedescedres.com",
    40
  );
  pdf.moveDown(1);
  pdf.text(
    "Je vous remercie et vous prie de croire, Monsieur, en l'expression de mes salutations distinguées.",
    40
  );
  pdf.moveDown(2);
  pdf.text("Docteur " + titleize(titulaire.fullName), 40);
  // #renseignements Branchet
  pdf.addPage();
  newBranchet(pdf, titulaire, remplacant, contrat);
  pdf.end();
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/ContratMedecin.js